import React from "react";
import styled from "styled-components";
import Spinner from "../../components/Spinner";

export const ModalButton = styled.button`
  width: 90px;
  height: 30px;
  font-size: 14px;
  font-family: Nunito;
  border-radius: 5px;
  border: none;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

export const ModalExportButton = styled.button`
  height: 40px;
  font-size: 16px;
  font-family: Nunito;
  border-radius: 5px;
  border: solid 1px #22af47;
  cursor: pointer;
  margin-right: 10px;
  background: none;
  color: #22af47;
  outline: none;
  &:hover {
    background: #22af47;
    color: white;
    outline: none;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    opacity: 0.5;
  }
`;
export const OptionsExportButton = styled.button`
  height: 40px;
  font-size: 16px;
  font-family: Nunito;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  margin-right: 10px;
  background: #f0f0f0;
  color: #293134;
  outline: none;
  &:hover {
    background: #f7f7f7;
    outline: none;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    opacity: 0.5;
  }
`;

export function StyledSpinnerButton({ isLoading, children, ...props }) {
  return (
    <OptionsExportButton type="button" {...props}>
      {isLoading ? <Spinner /> : children}
    </OptionsExportButton>
  );
}

export function SpinnerButtonPrimary({ isLoading, children, ...props }) {
  return (
    <ButtonPrimary type="button" {...props}>
      {isLoading ? <Spinner /> : children}
    </ButtonPrimary>
  );
}

export const ButtonPrimary = styled.button`
  display: flex;
  align-items: center;
  white-space: nowrap;
  min-width: fit-content;
  /* --------------- */
  font-size: ${({ fontSize }) => fontSize || "16px"};
  padding: ${({ padding }) => padding || "10px 20px"};
  max-height: ${({ maxHeight }) => maxHeight || "40px"};
  justify-content: ${({ justifyContent }) => justifyContent || ""};
  /* --------------- */
  /* width: 120px;
  height: 40px;
  font-size: 16px; */
  font-family: Nunito;
  border-radius: ${({ borderRadius }) => borderRadius || "5px"};
  border: none;
  cursor: pointer;
  margin-right: ${({ marginRight }) => marginRight || "10px"};
  background: #f0292a;
  color: white;
  outline: none;
  &:hover {
    background-color: #940e0a;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    opacity: 0.5;
  }
`;

export const ButtonSecondary = styled(ButtonPrimary)`
  background: none;
  border: 1px solid #f0292a;
  color: #f0292a;
  &:hover {
    background: #f0292a;
    color: white;
    opacity: 0.9;
  }
`;

export const CustomDropdown = styled.div`
  .dropdown-menu {
    padding: ${({ padding }) => padding || "10px"};
    width: ${({ width }) => width || "20rem"};
    align-items: center;
    box-shadow: ${({ boxShadow }) => boxShadow || "-3px 6px 21px 2px rgba(0, 0, 0, 0.8) !important"};
    background-color: #fff !important;
  }

  .dropdown-toggle {
    font-family: "Nunito";
    background-color: #f0292a !important;
    color: #fff;
    border: none;
    ${({ dropdownStyles }) => dropdownStyles && { ...dropdownStyles }}
    max-width: ${({ toggleMaxWidth }) => toggleMaxWidth || " "};
  }

  .dropdown-toggle:hover {
    cursor: pointer;
    opacity: 0.8;
  }

  .white {
    border: solid 1px #f0292a !important;
    background-color: #fff !important;
    color: #f0292a !important;
  }

  .white:hover {
    cursor: pointer;
    background-color: #f0292a !important;
    color: #fff !important;
    opacity: none;
  }

  .white-black {
    border: solid 1px #cccccc !important;
    border-radius: 4px !important;
    background-color: #fff !important;
    color: #293134 !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .white-black:hover {
    cursor: pointer;
    background-color: #cccccc !important;
    color: #293134 !important;
    opacity: none;
  }

  .filters-active {
    background-color: #f7f7f7 !important;
  }
`;
export const TagButton = styled.button`
  background-color: ${(props) => (props.isActive ? "#ffffff" : "#f8f8f8")};
  color: ${(props) => (props.isActive ? "#f0292a" : "#707070")};
  border: 1px solid ${(props) => (props.isActive ? "#f0292a" : "#707070")};
  border-radius: ${({ borderRadius }) => borderRadius || "5px"};
  padding: ${({ padding }) => padding || "5px 10px"};
  margin-right: 5px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  outline: none;

  :hover {
    background-color: #ffffff;
    color: #f0292a;
    border: 1px solid #f0292a;
    outline: none;
  }

  :focus {
    outline: none;
  }
`;

export const TagFiltersButton = styled.button`
  background-color: ${(backgroundColor) => backgroundColor || "#F7F7F7"};
  color: ${(color) => color || "#707070"};
  border: none;
  border-radius: ${({ borderRadius }) => borderRadius || "5px"};
  padding: ${({ padding }) => padding || "5px 10px"};
  margin-right: 5px;
  font-size: 12px;
  cursor: pointer;
  outline: none;

  :hover {
    background-color: #ffffff;
    color: #f0292a;
    border: 1px solid #f0292a;
    outline: none;
  }

  :focus {
    outline: none;
  }
`;

export const CircleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => size || "30px"};
  height: ${({ size }) => size || "30px"};
  border-radius: 50%;
  border: none;
  cursor: pointer;
  margin-right: ${({ marginRight }) => marginRight || "0px"};
  padding: ${({ padding }) => padding || "0px"};
  border: solid 2px #f0292a;
  background: white;
  color: #f0292a;
  outline: none;
  &:hover {
    opacity: 0.7;
  }
  &:focus {
    outline: none;
    opacity: 0.7;
  }
  &:disabled {
    opacity: 0.5;
  }
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  margin-right: ${({ marginRight }) => marginRight || "0px"};
  width: ${({ size }) => size || "auto"};
  height: ${({ size }) => size || "auto"};
  padding: 0;
  color: ${({ color }) => color || "#f0292a"};
  transition: all 0.2s ease;
  padding: 4px;

  ${({ isSelected }) =>
    isSelected &&
    `
      border-radius: 4px;
      box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2);  /* Sombreado para efecto de botón hundido */
      border: none;
      background-color: #f0292a !important;
      color: #fff;
    `}

  svg {
    stroke: ${(props) => (props.isSelected ? "#ccc" : "#333")};
    fill: ${(props) => (props.isSelected ? "white" : "none")};
    transition: stroke 0.3s ease, fill 0.3s ease;
  }

  &:hover,
  &:focus,
  &:active {
    outline: none;
    opacity: 0.7;
  }

  &:disabled {
    color: #ccc;
  }
`;

export const ToggleButton = styled.button`
  font-family: "Nunito";
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${({ border }) => border || "none"};
  background: none;
  cursor: pointer;
  margin-right: ${({ marginRight }) => marginRight || "0px"};
  width: ${({ width }) => width || "auto"};
  height: ${({ heigth }) => heigth || "40px"};
  padding: ${({ padding }) => padding || "5px"};
  color: #293134;
  transition: all 0.2s ease;
  border-radius: 4px !important;
  max-width: ${({ maxWidth }) => maxWidth || " "};
  box-shadow: 0 0 0 1px rgba(158, 158, 158, 0.1);

  ${({ isSelected }) =>
    isSelected &&
    `
      color: #293134 !important;
      background-color: #f7f7f7 !important;
      box-shadow: none !important;
    `}

  &:hover {
    border: 1px solid #cccccc !important;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2);
    background-color: #f7f7f7 !important;
  }
  &:focus,
  &:active {
    outline: none;
  }

  &:disabled {
    color: #ccc;
  }
`;

export const SimpleButton = styled.button`
  font-family: "Nunito";
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  margin-right: ${({ marginRight }) => marginRight || "0px"};
  width: ${({ size }) => size || "auto"};
  height: ${({ size }) => size || "auto"};
  padding: ${({ padding }) => padding || "5px"};
  color: #f0292a;
  transition: all 0.2s ease;

  &:hover,
  &:focus,
  &:active {
    outline: none;
    text-decoration: underline;
  }

  &:disabled {
    color: #ccc;
  }
`;
